import React, { useState, useEffect, useCallback } from 'react';
import {
  CardBody,
  Row,
  Col,
  Card,
  Container,
  CardHeader,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  Button,
} from 'reactstrap';
import DataTable from 'react-data-table-component';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import DeleteModal from '../../Components/Common/DeleteModal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { api } from '../../config';
import { getAuthToken } from '../../auth/tokenvalidation';

const LocationList = () => {
  const token = getAuthToken();

  const [data, setData] = useState({ items: [] });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [invoice, setInvoice] = useState(null);
  const [errors, setErrors] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalLocation, setModalLocation] = useState(false);
  const [locationFormData, setLocationFormData] = useState({
    name: null,
    description: null,
    id: null,
  });

  const [filterText, setFilterText] = useState('');
  const [loading, setLoading] = useState(false);

  const handleDeleteModal = id => {
    const selectedRow = data.items.find(item => item.id === id);
    setInvoice(selectedRow);
    setDeleteModal(true);
  };

  const handleDeleteInvoice = async () => {
    if (invoice) {
      try {
        const response = await fetch(`${api.API_URL}/location/${invoice.id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || `HTTP error! status: ${response.status}`
          );
        }

        toast.success('Location berhasil dihapus!', { autoClose: 3000 });
        setDeleteModal(false);
        setInvoice(null);
        fetchData(currentPage, rowsPerPage, token, filterText);
      } catch (err) {
        toast.error(`Gagal menghapus location: ${err.message}`, {
          autoClose: 3000,
        });
      }
    }
  };

  const deleteMultiple = () => {
    // Implement multiple delete functionality
    // This would typically involve deleting selected items
    // For now, just close the modal
    setDeleteModalMulti(false);
  };

  const columns = [
    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Location Name
        </span>
      ),
      selector: row => row.name,
      sortable: true,
      width: '40%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.name || '-'}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Description
        </span>
      ),
      selector: row => row.description,
      sortable: true,
      width: '45%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.description || '-'}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Action
        </span>
      ),
      width: '15%',
      sortable: false,
      className: 'text-end',
      cell: row => (
        <div className='d-flex gap-1 justify-content-end'>
          <button
            className='btn btn-soft-info btn-sm btn-icon'
            onClick={() => handleUpdateModal(row.id)}
          >
            <i className='ri-pencil-fill align-bottom'></i>
          </button>
          <button
            className='btn btn-soft-danger btn-sm btn-icon'
            onClick={() => handleDeleteModal(row.id)}
          >
            <i className='ri-delete-bin-6-line align-bottom'></i>
          </button>
        </div>
      ),
    },
  ];

  document.title = 'Data Location';

  const handleChange = e => {
    const { name, value } = e.target;
    setLocationFormData({ ...locationFormData, [name]: value });
  };

  useEffect(() => {
    fetchData(currentPage, rowsPerPage, token, filterText);
  }, [currentPage, rowsPerPage, token, filterText]);

  const handleFilterChange = e => {
    setFilterText(e.target.value);
    setCurrentPage(1); // Reset ke halaman pertama saat kata kunci berubah
  };

  const clearFilter = () => {
    setFilterText('');
    setCurrentPage(1);
  };

  const fetchData = async (currentPage, rowsPerPage, token, searchText) => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        PageNumber: currentPage.toString(),
        PageSize: rowsPerPage.toString(),
      });
      if (searchText) {
        queryParams.append('Name', searchText);
      }

      const response = await fetch(
        `${api.API_URL}/location?${queryParams.toString()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          credentials: 'same-origin',
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      // Handle different possible response structures
      const items =
        result?.data?.items || result?.items || result?.data || result || [];
      const totalItems =
        result?.data?.totalItems || result?.totalItems || items.length;

      setData({
        items: Array.isArray(items) ? items : [],
      });
      setTotalRows(totalItems);
    } catch (error) {
      toast.error(`Failed to load data: ${error.message}`);
      setData({ items: [] });
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = useCallback(page => {
    setCurrentPage(page);
  }, []);

  const handlePerRowsChange = useCallback(newPerPage => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1);
  }, []);

  const handleNewModal = () => {
    setLocationFormData({
      name: null,
      description: null,
      id: null,
    });
    locationModal();
  };

  const handleUpdateModal = (mid = null) => {
    fetchLocationDetail(mid);
    locationModal();
  };

  const locationModal = () => {
    setModalLocation(!modalLocation);
  };

  const selectedFieldsLocation = {
    name: locationFormData.name,
    description: locationFormData.description,
  };

  const handleAddDataLocation = async () => {
    try {
      await axios.post(`${api.API_URL}/location`, selectedFieldsLocation, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(`Location Has been Added`);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
    } finally {
      fetchData(currentPage, rowsPerPage, token, filterText);
    }
  };

  const fetchLocationDetail = async mid => {
    try {
      const response = await axios.get(`${api.API_URL}/location/${mid}`, {
        withXSRFToken: true,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: `application/json`,
        },
      });
      // Interceptor global (src/helpers/api_helper.js) sudah meng-unwrap
      // `response.data`, jadi `response` adalah envelope { success, message, data }.
      // Kupas satu lapis lagi, tetap toleran kalau bentuknya berbeda.
      const data = response?.data?.data ?? response?.data ?? response;
      setLocationFormData({
        name: data.name || null,
        description: data.description || null,
        id: data.id || null,
      });
    } catch (error) {
      toast.error(`Failed to fetch location details: ${error.message}`);
    }
  };

  const handleUpdDataLocation = async mid => {
    try {
      await axios.put(
        `${api.API_URL}/location/${mid}`,
        selectedFieldsLocation,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data Has been Updated`);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
    } finally {
      fetchData(currentPage, rowsPerPage, token, filterText);
    }
  };

  return (
    <React.Fragment>
      <div className='page-content'>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={() => handleDeleteInvoice()}
          onCloseClick={() => setDeleteModal(false)}
        />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid>
          <BreadCrumb title='View Data' pageTitle='Location' />

          <Row>
            <Col lg={12}>
              <Card id='LocationList'>
                <CardHeader className='border-0'>
                  <div className='d-flex align-items-center'>
                    <h5 className='card-title mb-0 flex-grow-1'>
                      Data Location
                    </h5>
                    <div className='flex-shrink-0'>
                      <div className='d-flex gap-2 flex-wrap'>
                        <button
                          type='button'
                          className='btn btn-primary btn-label right ms-auto nexttab btn-sm'
                          onClick={() => handleNewModal()}
                        >
                          <i className='ri-play-list-add-line label-icon align-middle fs-16 ms-2'></i>{' '}
                          <span className='d-none d-sm-inline'>
                            Create New Location
                          </span>
                          <span className='d-sm-none'>New</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Filter Section */}
                  <div className='d-flex justify-content-between align-items-center mt-3'>
                    <div className='d-flex align-items-center gap-2'>
                      <Input
                        type='text'
                        placeholder='Search locations...'
                        value={filterText}
                        onChange={handleFilterChange}
                        style={{ width: '300px' }}
                        className='form-control-sm'
                      />
                      {filterText && (
                        <Button
                          color='secondary'
                          size='sm'
                          onClick={clearFilter}
                          outline
                        >
                          <i className='ri-close-line'></i> Clear
                        </Button>
                      )}
                    </div>
                  </div>
                </CardHeader>

                <CardBody className='pt-0'>
                  <div
                    className='table-responsive'
                    style={{
                      minHeight: 'auto',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <DataTable
                      columns={columns}
                      highlightOnHover
                      data={data.items}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      onChangePage={handlePageChange}
                      onChangeRowsPerPage={handlePerRowsChange}
                      showPaginationBottom={true}
                      wrap
                      dense
                      striped
                      progressPending={loading}
                      fixedHeader={false}
                      fixedHeaderScrollHeight={undefined}
                      noDataComponent={
                        <div
                          style={{
                            padding: '20px',
                            textAlign: 'center',
                            color: '#6c757d',
                          }}
                        >
                          <i
                            className='ri-database-2-line'
                            style={{
                              fontSize: '32px',
                              marginBottom: '8px',
                              display: 'block',
                            }}
                          ></i>
                          {filterText
                            ? 'No locations match the current filter'
                            : 'No locations found'}
                        </div>
                      }
                      defaultSortFieldId={1}
                      defaultSortAsc={true}
                      customStyles={{
                        header: {
                          style: {
                            backgroundColor: '#f0f0f0',
                            color: '#333',
                            fontWeight: 'bold',
                          },
                        },
                        headCells: {
                          style: {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            borderRight: '1px solid #dee2e6',
                          },
                        },
                        cells: {
                          style: {
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            wordBreak: 'break-word',
                            borderRight: '1px solid #dee2e6',
                          },
                        },
                        rows: {
                          style: {
                            minHeight: '50px',
                            '&:hover': {
                              backgroundColor: '#f8f9fa',
                            },
                          },
                        },
                        table: {
                          style: {
                            width: '100%',
                            minWidth: '100%',
                            tableLayout: 'fixed',
                          },
                        },
                        responsiveWrapper: {
                          style: {
                            overflowX: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                          },
                        },
                        pagination: {
                          style: {
                            borderTop: '1px solid #dee2e6',
                            backgroundColor: '#f8f9fa',
                            margin: 0,
                            padding: '8px 0',
                          },
                        },
                      }}
                    />

                    <ToastContainer closeButton={false} limit={1} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal
            isOpen={modalLocation}
            role='dialog'
            autoFocus={true}
            centered
            id='addLocationModal'
            toggle={locationModal}
            data-bs-backdrop='static'
            size='md'
          >
            <ModalHeader
              className='bg-soft-info'
              toggle={() => {
                setModalLocation(!modalLocation);
              }}
            >
              <span className='modal-title text-info fw-bold'>
                {locationFormData.id !== null
                  ? 'Edit Location'
                  : 'Add Location'}
              </span>
            </ModalHeader>

            <ModalBody>
              <div className='d-flex mt-2'>
                <Col sm={12}>
                  <Row>
                    <Col sm={12}>
                      <div className='mb-3'>
                        <Label for='location-name' className='form-label '>
                          Location Name :
                        </Label>
                        <div className='input-group'>
                          <Input
                            type='text'
                            id='name'
                            name='name'
                            className='form-control'
                            value={locationFormData.name || ''}
                            onChange={e => {
                              handleChange(e);
                              setErrors({
                                ...errors,
                                name: '',
                              });
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div>
                        <Label htmlFor='description' className='form-label'>
                          Description{' '}
                        </Label>
                        <textarea
                          className='form-control'
                          id='description'
                          name='description'
                          rows='5'
                          value={locationFormData.description || ''}
                          onChange={e => {
                            handleChange(e);
                            setErrors({
                              ...errors,
                              description: '',
                            });
                          }}
                        ></textarea>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </div>
            </ModalBody>

            <ModalFooter>
              <Button
                color='danger'
                className='btn-label btn-sm right'
                onClick={() => {
                  setModalLocation(!modalLocation);
                }}
              >
                {' '}
                <i className=' ri-close-circle-line label-icon align-middle fs-16 ms-2'></i>{' '}
                Close
              </Button>
              <Button
                color='primary'
                className='btn-label btn-sm right'
                onClick={() => {
                  setModalLocation(!modalLocation);
                  locationFormData.id !== null
                    ? handleUpdDataLocation(locationFormData.id)
                    : handleAddDataLocation();
                }}
              >
                {' '}
                <i className='ri-database-2-line label-icon align-middle fs-16 ms-2'></i>{' '}
                {locationFormData.id !== null ? 'Update' : 'Save'}
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LocationList;
